<form
	[formGroup]="form"
	(ngSubmit)="onSubmit()"
	class="space-y-6 border border-gray-100 p-5 rounded-md shadow-md"
>
	<div class="flex justify-start">
		<activar-button-switch style="width: 150px;"
			[buttons]="typeButtons"
			(clickButton)="setClientType($event)"
		/>
	</div>

	@if (isPersonType) {
		<div class="flex gap-5">
			<div class="w-full">
				<label for="firstName">Nombre</label>
				<input
					type="text"
					id="firstName"
					formControlName="firstName"
					class="input__base"
				/>
				<app-input-error [control]="form.get('firstName')" [submitted]="submitted()" />
			</div>

			<div class="w-full">
				<label for="lastName">Apellido</label>
				<input
					type="text"
					id="lastName"
					formControlName="lastName"
					class="input__base"
				/>
				<app-input-error [control]="form.get('lastName')" [submitted]="submitted()" />
			</div>
		</div>
	}

	@if (isCompanyType) {
		<div class="flex gap-5">
			<div class="w-full">
				<label for="companyName">Razón Social</label>
				<input
					type="text"
					id="companyName"
					formControlName="companyName"
					class="input__base"
				/>
				<app-input-error [control]="form.get('companyName')" [submitted]="submitted()" />
			</div>
		</div>
	}

	<div class="flex gap-5">
		<div class="w-full">
			<label for="identification">{{ identificationLabel }}</label>
			@if (isPersonType) {
				<input
					type="text"
					id="identification"
					formControlName="identification"
					class="input__base"
					[mask]="identificationMask"
				/>
			} @else {
				<input
					type="text"
					id="identification"
					formControlName="identification"
					class="input__base"
					[mask]="identificationMask"
					cuitBlurNormalize
				/>
			}
			<app-input-error [control]="form.get('identification')" [submitted]="submitted()" />
		</div>

		<div class="w-full">
			<label for="email">Email</label>
			<input
				type="email"
				id="email"
				formControlName="email"
				class="input__base"
				placeholder="ejemplo@correo.com"
			/>
			<app-input-error [control]="form.get('email')" [submitted]="submitted()" />
		</div>
	</div>

	<div class="flex gap-5">
		<div class="w-full">
			<label for="address">Dirección</label>
			<input
				type="text"
				id="address"
				formControlName="address"
				class="input__base"
			/>
			<app-input-error [control]="form.get('address')" [submitted]="submitted()" />
		</div>

		<div class="w-full">
			<label for="postalCode">Código Postal</label>
			<input
				type="text"
				id="postalCode"
				formControlName="postalCode"
				class="input__base"
				maxlength="4"
				(change)="checkPostalCode()"
			/>
			<app-input-error [control]="form.get('postalCode')" [submitted]="submitted()" />

			<input type="hidden" formControlName="zoneId" />

			@if (zones().length > 1) {
				<div class="mt-2">
					<label for="zone-select">Selecciona la zona</label>
					<select
						id="zone-select"
						class="input__base mt-1"
						[class.error]="submitted() && !selectedZone()"
						(change)="onZoneSelect($event)">
						<option value="">Selecciona una zona</option>
						@for (zone of zones(); track zone.id) {
							<option [value]="zone.id">{{ zone.name }} - {{ zone.province.name }}</option>
						}
					</select>
					@if (submitted() && !selectedZone()) {
						<div class="text-red-500 text-sm mt-1">Debe seleccionar una zona.</div>
					}
				</div>
			}

			@if (checkingPostalCode()) {
				<div class="text-sm text-gray-600 mt-2">
					Verificando código postal...
				</div>
			}
		</div>
	</div>

	<div class="flex justify-end items-end pt-4">
		<activar-button
			type="submit"
			text="Crear usuario"
			[loadingText]="'Creando...'"
			[loading]="loading()"
			[disabled]="loading() || !form.valid"
			fill="solid"
			color="primary"
			expand="block"
		/>
	</div>
</form>
